import { render, staticRenderFns } from "./scanPreview.vue?vue&type=template&id=6afb8ae8&scoped=true&"
import script from "./scanPreview.vue?vue&type=script&lang=js&"
export * from "./scanPreview.vue?vue&type=script&lang=js&"
import style0 from "./scanPreview.vue?vue&type=style&index=0&id=6afb8ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afb8ae8",
  null
  
)

export default component.exports